import { render, staticRenderFns } from "./ModalAddNewManagerChatWhatsApp.vue?vue&type=template&id=2bf2187a&"
import script from "./ModalAddNewManagerChatWhatsApp.vue?vue&type=script&lang=js&"
export * from "./ModalAddNewManagerChatWhatsApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports